var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.boldLast
    ? _c(_vm.element_type, { tag: "component" }, [
        _c(
          "span",
          { staticClass: "font-weight-normal", class: _vm.cls.first },
          [_vm._v(_vm._s(_vm.first))]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "font-weight-bold", class: _vm.cls.last }, [
          _vm._v(_vm._s(_vm.last))
        ])
      ])
    : _c(_vm.element_type, { tag: "component" }, [
        _c("span", { staticClass: "font-weight-bold", class: _vm.cls.first }, [
          _vm._v(_vm._s(_vm.first))
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "font-weight-normal", class: _vm.cls.last }, [
          _vm._v(_vm._s(_vm.last))
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01bdc1ed", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01bdc1ed","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/BoldWords.vue
// module id = 717
// module chunks = 0